const keyEvent = 'taber.event'

class Taber {
  constructor (logger) {
    this.l = logger
  }
  debug (msg) {
    this.l.debug('taber', msg)
  }
  emit (name, data) {
    const e = JSON.stringify({
      data: data,
      name: name
    })
    this.debug('sending ' + e)
    localStorage.setItem(keyEvent, e)
    localStorage.removeItem(keyEvent)
  }
  on (name, listener) {
    window.addEventListener('storage', e => {
      // Invalid key
      if (e.key !== keyEvent) return

      // Parse
      var p
      try {
        p = JSON.parse(e.newValue)
      } catch (err) {}
      if (!p) return

      // Not the same name
      if (p.name !== name) return

      // Log
      this.debug('handling ' + e.newValue)

      // Custom
      listener(p.data)
    })
  }
}

export default Taber
